import React from 'react';

const Footer = (props) =>{
    return(
        <footer>
        <h3 className='h3_footer'> 📞3456 547932	</h3>
 	    <h3 className='h3_footer'> 📧tomasbenitezc13@gmail.com </h3>
        </footer> 
    );
}
export {Footer};